import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PapiTopic } from '@wix/da-papi-types';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import {
  BiContextProvidedValue,
  BiData,
  ItemClickBiEvent,
} from '@wix/da-bi/pkg/events';

import s from './RelatedTopics.scss';

// spec: limit number of topics
export const MAX_TOPICS = 5;

export interface Props {
  topics?: PapiTopic[];
  className?: string;
}

export const RelatedTopics: React.FC<Props> = ({ topics = [], className }) => {
  const { t } = useTranslation();
  const first5Topics = topics.slice(0, MAX_TOPICS);
  if (first5Topics.length <= 0) {
    return null;
  }

  return (
    <nav className={classnames(s['root'], className)}>
      <h6 className={s['title']}>{t('topicPage.topicHeader.relatedTopics')}</h6>

      <ul className={s['list']}>
        {first5Topics.map(topic => (
          <li className={s['topic']} key={topic.name}>
            <BiLink
              href={topic.url}
              biData={BiData<ItemClickBiEvent>({
                evid: 100,
                typeid: topic.typeId,
                itemid: topic.itemId,
                sectionname: 'related_topics',
                sectionid: BiContextProvidedValue,
                section_typeid: BiContextProvidedValue,
              })}
            >
              {topic.name}
            </BiLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};
RelatedTopics.displayName = 'RelatedTopicsC105M';
export default RelatedTopics;
